import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { JSX } from "react";

interface ConfirmationDialogProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  msg: JSX.Element;
  handleSubmit: () => void;
  handleCancel?: () => void;
}

const ConfirmationDialog = (props: ConfirmationDialogProps) => {
  return (
    <Dialog open={props.open}>
      <DialogContent dividers sx={{ lineHeight: 1.5, py: 1 }}>
        <Typography
          variant="h5"
          sx={{
            display: "flex",
            justifyContent: "center",
            py: 1,
            color: "red",
          }}
        >
          Potvrdit akci
        </Typography>

        {props.msg}
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center" }}>
        <Button
          variant="contained"
          className="submitBtn"
          onClick={() => {
            props.handleCancel?.();
            props.setOpen(false);
          }}
          sx={{ mr: 1.5 }}
        >
          NE
        </Button>
        <Button
          variant="contained"
          className="deleteBtn"
          onClick={props.handleSubmit}
        >
          ANO
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
